import React from 'react';
import DashboardLayout from '../Layout/DashboardLayout';
import ManageArticles from './ManageArticles/ManageArticles';

export default function DashboardPage() {
  return (
    <DashboardLayout>
    </DashboardLayout>
  );
}